import type { MapDef } from '@warcarp/api-types'

export function isWarfishClassicsMap(map: Pick<MapDef, 'legacy'> | null | undefined): boolean {
  return map?.legacy === 'warfish'
}

export const WARFISH_CLASSICS_LONG_FORM = 'Warfish.net classic boards'
export const WARFISH_CLASSICS_CAPTION = 'a Warfish.net classic board'
export const WARFISH_CLASSICS_TAG = 'Warfish.net Classics'
export const WARFISH_CLASSICS_HELP_LABEL = 'About Warfish.net classic boards'
export const WARFISH_CLASSICS_EXPLANATION = 'Warfish.net was originally created in 2005, before modern mobile devices. Warfish.net classic boards adapt its desktop maps for WarCarp. \n\nTheir dense layouts were designed for desktop play and may feel better on a desktop or larger screen. Mobile play is supported; zoom in to read troop counts and select territories.'


export function warfishClassicsMapStaleTime(map: Pick<MapDef, 'legacy'> | null | undefined, qa: boolean): number {
  return qa && isWarfishClassicsMap(map) ? 0 : Infinity
}
